/**
 * Баннер на первом экране главной страницы
 */
$.fn.mainBannerSlider = function() {
    const $self = $(this);
    const $slides = $self.find('.js-slide-item');
    const $bullets = $self.find('.js-bullet-item');
    const $previews = $self.find('.js-banner-previews');
    const $firstPreview = $previews.find('.js-preview-item').first();
    const $lastPreview = $previews.find('.js-preview-item').last();
    const $slider = $self.find('.js-main-banner-slider');
    let switchInterval;

    let currentIndex = 1;

    /**
     * Меняем превьюхи
     * @param {jquery} $slide
     */
    const changePreview = ($slide) => {
        if ($previews.length) {

            const firstPreviewUrl = $lastPreview.attr('href');
            const firstPreviewText = $lastPreview.find('.js-preview-text.active').text();
            const firstPreviewImgSrc = $lastPreview.find('.js-preview-img.active')
                .attr('src');

            const lastPreviewUrl = $slide.attr('href');
            const lastPreviewText = $slide.find('.js-description-text').text();
            const lastPreviewImgSrc = $slide.find('.js-slide-img')
                .attr('src');

            $firstPreview.attr('href', firstPreviewUrl);
            $firstPreview.find('.js-preview-text:not(.active)').text(firstPreviewText);
            $firstPreview.find('.js-preview-img:not(.active)').attr('src', firstPreviewImgSrc);

            $lastPreview.attr('href', lastPreviewUrl);
            $lastPreview.find('.js-preview-text:not(.active)').text(lastPreviewText);
            $lastPreview.find('.js-preview-img:not(.active)').attr('src', lastPreviewImgSrc);

            $previews.find('.js-preview-item').each( function () {
                const $text = $(this).find('.js-preview-text');
                const $img = $(this).find('.js-preview-img');

                $text.each(function () {
                    if ($(this).hasClass('active')) {
                        $(this).removeClass('active');
                    } else {
                        $(this).addClass('active');
                    }
                });

                $img.each(function () {
                    if ($(this).hasClass('active')) {
                        $(this).removeClass('active');
                    } else {
                        $(this).addClass('active');
                    }
                });
            });
        }
    };

    /**
     * Переключаем слайд
     */
    const changeSlide = () => {
        const $currentSlide = $self.find('.js-slide-item.active');
        const $nextSlide = $slides.eq(currentIndex % $slides.length);

        $slides.removeClass('active');
        $nextSlide.addClass('active');
        $bullets.removeClass('active');
        $bullets.eq(currentIndex % $bullets.length).addClass('active');
        changePreview($currentSlide);
        currentIndex++;
    };

    const goToSlide = (indexSlide) => {
        const currentSlideIndex = (currentIndex % $slides.length);
        const $currentSlide = $self.find('.js-slide-item.active');

        $slides.removeClass('active');
        $bullets.removeClass('active');

        changePreview($currentSlide);
        (currentSlideIndex > indexSlide) ? currentIndex-- : currentIndex++;
        $slides.eq(indexSlide).addClass('active');
        $bullets.eq(indexSlide).addClass('active');

        clearInterval(switchInterval);
        switchInterval = setInterval(changeSlide, 5000);
    };

    const initEvents = () => {
        $(document).on('click', '.js-bullet-item', function () {
            goToSlide($(this).index());
        });
    };

    /**
     * Инициализация плагина
     */
    const init = () => {

        if (typeof $.fn.swipe !== 'undefined') {
            $slider.swipe({
                preventDefaultEvents: false,
                swipe: function(event, direction) {
                    switch (direction) {
                        case 'left':
                            goToSlide(($slides.filter('.active').index() + 1) % $slides.length);
                            break;
                        case 'right':
                            goToSlide(($slides.filter('.active').index() - 1 + $slides.length) % $slides.length);
                            break;
                    }
                },
            });
        };
        initEvents();

        switchInterval = setInterval(changeSlide, 5000);
    };

    this.init = init;

    return this;

};
